module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "viewport-size",
    staticStyle: {
      "background-color": "#F6F6F6",
      "position": "relative",
      "z-index": "-2"
    }
  }, [_c('div', {
    staticClass: "main-background-image-container_"
  }, [_c('picture', [_c('source', {
    staticClass: "main-background-image",
    attrs: {
      "media": "(min-width:600px)",
      "srcset": "static/img/main-background.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "main-background-image",
    attrs: {
      "media": "(min-width:600px)",
      "srcset": "static/img/main-background.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-background-image",
    attrs: {
      "src": "about:blank"
    }
  })])], 1), _vm._v(" "), _c('h1', {
    staticClass: "haqcs-heading-1"
  }, [_vm._v("HAQCS")]), _vm._v(" "), _c('h2', {
    staticClass: "haqcs-heading-2"
  }, [_vm._v("Hapla Air Quality Control System.")]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "main-image",
    attrs: {
      "media": "(min-width:600px)",
      "srcset": "static/haqcs-renderings/main.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "main-image",
    attrs: {
      "srcset": "static/haqcs-renderings/main_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "main-image",
    attrs: {
      "srcset": "static/haqcs-renderings/main.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-image",
    attrs: {
      "src": "static/haqcs-renderings/main.png"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "main-image"
  })], 1), _vm._v(" "), _c('div', {
    ref: "haqcs-is",
    staticClass: "haqcs-is"
  }, [_c('div', {
    staticClass: "container_ top"
  }, [_c('div', {
    class: [_vm.showBothModes ? 'both' : 'single', 'flex-container_']
  }, [_c('div', {
    staticClass: "content content-heading",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.lng.haqcsIs) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content content-as-controller"
  }, [_c('div', {
    staticClass: "tile controller"
  }, [_c('picture', [_c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "media": "(min-width:800px)",
      "srcset": "static/img/haqcs-renderings/gray-auto_1046px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "srcset": "static/img/haqcs-renderings/gray-auto_400px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect haqcs",
    attrs: {
      "src": "static/img/haqcs-renderings/gray-auto_min.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lng.aController))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content content-as-monitor"
  }, [_c('div', {
    staticClass: "tile monitor"
  }, [_c('picture', [_c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "media": "(min-width:800px)",
      "srcset": "static/img/haqcs-renderings/display/webp_1046px/green-comfort.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "srcset": "static/img/haqcs-renderings/display/webp_400px/green-comfort.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect haqcs",
    attrs: {
      "src": "static/img/haqcs-renderings/display/png/green-comfort.png"
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lng.aMonitor))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#F6F6F6",
      "padding-bottom": "10vh"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "rgb(253, 253, 253)",
      "padding-bottom": "5vh"
    }
  }), _vm._v(" "), _c('div', {
    ref: "haqcs-as-a-monitor",
    attrs: {
      "id": "haqcs-as-a-monitor"
    }
  }, [_c('div', {
    class: ['header-bar', 'top', (_vm.headerBarStickingMonitor) ? 'header-bar-sticking' : 'header-bar-not-sticking']
  }, [_c('div', {
    staticClass: "header-bar-container_"
  }, [_c('h2', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "line-height": "5vh"
    }
  }, [_c('span', {
    staticClass: "top-heading"
  }, [_vm._v(_vm._s(_vm.lng.haqcsAsA))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#haqcs-as-a-monitor'),
      expression: "'#haqcs-as-a-monitor'"
    }],
    staticClass: "top-heading top-heading-item"
  }, [_vm._v(_vm._s(_vm.lng.measuringDevice))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#haqcs-as-a-controller'),
      expression: "'#haqcs-as-a-controller'"
    }],
    staticClass: "top-heading top-heading-item top-heading-inactive"
  }, [_vm._v(_vm._s(_vm.lng.controller))]), _c('span', {
    staticClass: "top-heading"
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-and-up"
  }, [_c('span', {
    staticClass: "top-heading"
  }, [_vm._v(_vm._s(_vm.lng.haqcsAsA) + " " + _vm._s(_vm.lng.measuringDevice) + ".")])]), _vm._v(" "), _c('p', {
    staticClass: "top-paragraph"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.measuringDeviceTopParagraph) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    class: ['shadow', (_vm.headerBarStickingMonitor) ? 'shadow-visible' : 'shadow-invisible']
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "haqcs-as-a-monitor"
    }
  }, [_c('div', {
    staticClass: "vertical-dots-container_ top"
  }, [_c('div', {
    staticClass: "centered-dots-container_"
  }, _vm._l((3), function(i) {
    return _c('div', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('#slide_' + String(i - 1)),
        expression: "'#slide_'+String(i-1)"
      }],
      key: i,
      class: ['single-dot-container_', (_vm.viewedSlide + 1) == i ? 'single-dot-container_-active' : '']
    }, [_c('span', {
      class: ['dot', (_vm.viewedSlide + 1) == i ? '' : 'dot-inactive']
    })])
  }))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "-100vh"
    }
  }), _vm._v(" "), _c('div', {
    ref: "haqcs-display",
    staticClass: "haqcs-display top",
    style: ({
      transform: 'translateY(' + _vm.haqcsOffset + 'vh)'
    })
  }, [_c('div', {
    staticClass: "container_"
  }, [_c('div', {
    staticClass: "img-container_"
  }, [_vm._l((['red', 'green', 'gray']), function(color) {
    return _c('div', {
      key: color
    }, _vm._l((['comfort', 'history']), function(display) {
      return _c('div', {
        key: display
      }, [_c('picture', [_c('source', {
        class: [(_vm.viewedHaqcsColor == color && _vm.viewedHaqcsDisplay == display) ? '' : 'inactive'],
        attrs: {
          "media": "(min-width:800px)",
          "srcset": 'static/img/haqcs-renderings/display/webp_1046px/' + color + '-' + display + '.webp',
          "type": "image/webp"
        }
      }), _vm._v(" "), _c('source', {
        class: [(_vm.viewedHaqcsColor == color && _vm.viewedHaqcsDisplay == display) ? '' : 'inactive'],
        attrs: {
          "srcset": 'static/img/haqcs-renderings/display/webp_400px/' + color + '-' + display + '.webp',
          "type": "image/webp"
        }
      }), _vm._v(" "), _c('img', {
        class: [(_vm.viewedHaqcsColor == color && _vm.viewedHaqcsDisplay == display) ? '' : 'inactive'],
        attrs: {
          "src": '../../static/img/haqcs-renderings/display/png/' + color + '-' + display + '.png'
        }
      })])], 1)
    }))
  }), _vm._v(" "), _c('picture', [_c('source', {
    staticStyle: {
      "opacity": "1.0",
      "position": "relative",
      "z-index": "-1"
    },
    attrs: {
      "media": "(min-width:800px)",
      "srcset": 'static/img/haqcs-renderings/display/webp_1046px/' + _vm.viewedHaqcsColor + '-' + _vm.viewedHaqcsDisplay + '.webp',
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticStyle: {
      "opacity": "1.0",
      "position": "relative",
      "z-index": "-1"
    },
    attrs: {
      "srcset": 'static/img/haqcs-renderings/display/webp_400px/' + _vm.viewedHaqcsColor + '-' + _vm.viewedHaqcsDisplay + '.webp',
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "opacity": "1.0",
      "position": "relative",
      "z-index": "-1"
    },
    attrs: {
      "src": '../../static/img/haqcs-renderings/display/png/' + _vm.viewedHaqcsColor + '-' + _vm.viewedHaqcsDisplay + '.png'
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "color-selector"
  }, _vm._l((_vm.colors), function(c) {
    return _c('span', {
      key: c[0],
      class: [(c[0] == _vm.selectedColor) ? 'active' : 'inactive'],
      on: {
        "click": function($event) {
          _vm.selectedColor = c[0]
        }
      }
    }, [_c('span', {
      staticClass: "bead",
      style: ({
        background: 'linear-gradient(to bottom,' + c[1] + ',' + c[c[0] == _vm.selectedColor ? 2 : 1] + ')'
      })
    }, [_c('span', {
      staticClass: "shiny",
      class: [c[0] == _vm.selectedColor ? '' : 'invisible']
    })])])
  })), _vm._v(" "), _c('p', {
    class: [_vm.viewedSlide == 2 ? 'invisible' : ''],
    staticStyle: {
      "position": "absolute"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.historyDisplay)
    }
  })]), _vm._v(" "), _c('p', {
    class: [_vm.viewedSlide == 2 ? '' : 'invisible']
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.comfortDisplay)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "margin-bottom": "-100vh"
    }
  }), _vm._v(" "), _c('div', {
    ref: "slide_0",
    staticClass: "slide slide0",
    attrs: {
      "id": "slide_0"
    }
  }, [_c('p', {
    ref: "slideText_0",
    class: ['text', (_vm.viewedSlide == 0) ? '' : 'text-not-viewed']
  }, [_c('b', [_vm._v(_vm._s(_vm.lng.slideText[0][0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.slideText[0][1])
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "slide_1",
    staticClass: "slide slide1",
    attrs: {
      "id": "slide_1"
    }
  }, [_c('p', {
    ref: "slideText_1",
    class: ['text', (_vm.viewedSlide == 1) ? '' : 'text-not-viewed']
  }, [_c('b', [_vm._v(_vm._s(_vm.lng.slideText[1][0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.slideText[1][1])
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "slide_2",
    staticClass: "slide slide2",
    attrs: {
      "id": "slide_2"
    }
  }, [_c('p', {
    ref: "slideText_2",
    class: ['text', (_vm.viewedSlide == 2) ? '' : 'text-not-viewed']
  }, [_c('b', [_vm._v(_vm._s(_vm.lng.slideText[2][0]))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.slideText[2][1])
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "slide_3",
    staticClass: "slide3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-slide"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('picture', [_c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "media": "(min-width:600px)",
      "srcset": "static/img/haqcs-photos/leds_1024px.webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/haqcs-photos/leds_2000px.webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "srcset": "static/img/haqcs-photos/leds_800px.webp",
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "button-card-img noselect",
    attrs: {
      "src": "static/img/haqcs-photos/leds.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-background-fade"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.photoTextLED) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "media": "(max-width:800px)",
      "srcset": "static/img/haqcs-photos/leds_small_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "media": "(max-width:1023px)",
      "srcset": "static/img/haqcs-photos/leds_small_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "srcset": "about:blank",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "src": "static/img/haqcs-photos/leds.jpg"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "img-slide img-slide-dark"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('picture', [_c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "media": "(min-width:600px)",
      "srcset": "static/img/haqcs-photos/alarms_1024px.webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/haqcs-photos/alarms_2000px.webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "button-card-img noselect",
    attrs: {
      "srcset": "static/img/haqcs-photos/alarms_800px.webp",
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "button-card-img noselect",
    attrs: {
      "src": "static/img/haqcs-photos/alarms.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-background-fade"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-container_"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.photoTextAlarms) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "media": "(max-width:800px)",
      "srcset": "static/img/haqcs-photos/alarms_small_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "media": "(max-width:1023px)",
      "srcset": "static/img/haqcs-photos/alarms_small_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "srcset": "about:blank",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "small-image hidden-md-and-up",
    attrs: {
      "src": "static/img/haqcs-photos/alarms.jpg"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "rgb(253, 253, 253)",
      "padding-bottom": "15vh"
    }
  }), _vm._v(" "), _c('div', {
    ref: "haqcs-as-a-controller",
    attrs: {
      "id": "haqcs-as-a-controller"
    }
  }, [_c('div', {
    class: ['header-bar', 'top', (_vm.headerBarStickingController) ? 'header-bar-sticking' : 'header-bar-not-sticking']
  }, [_c('div', {
    staticClass: "header-bar-container_"
  }, [_c('h2', {
    staticClass: "hidden-sm-and-down",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "line-height": "5vh"
    }
  }, [_c('span', {
    staticClass: "top-heading"
  }, [_vm._v(_vm._s(_vm.lng.haqcsAsA))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#haqcs-as-a-monitor'),
      expression: "'#haqcs-as-a-monitor'"
    }],
    staticClass: "top-heading top-heading-item top-heading-inactive"
  }, [_vm._v(_vm._s(_vm.lng.measuringDevice))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#haqcs-as-a-controller'),
      expression: "'#haqcs-as-a-controller'"
    }],
    staticClass: "top-heading top-heading-item"
  }, [_vm._v(_vm._s(_vm.lng.controller))]), _c('span', {
    staticClass: "top-heading"
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-and-up"
  }, [_c('span', {
    staticClass: "top-heading"
  }, [_vm._v(_vm._s(_vm.lng.haqcsAsA) + " " + _vm._s(_vm.lng.controller) + ".")])]), _vm._v(" "), _c('p', {
    staticClass: "top-paragraph"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.controllerTopParagraph) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    class: ['shadow', (_vm.headerBarStickingController) ? 'shadow-visible' : 'shadow-invisible']
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-of-haqcs"
  }, [_c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/0.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/0.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev0",
    attrs: {
      "src": "static/img/devices/webp/0.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/1.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/1.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev1",
    attrs: {
      "src": "static/img/devices/webp/1.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/2.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/2.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev2",
    attrs: {
      "src": "static/img/devices/webp/2.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "media": "(min-width:800px)",
      "srcset": "static/img/haqcs-renderings/gray-auto_1046px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect haqcs",
    attrs: {
      "srcset": "static/img/haqcs-renderings/gray-auto_400px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect haqcs",
    attrs: {
      "src": "static/img/haqcs-renderings/gray-auto_min.png"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/3.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/3.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev3",
    attrs: {
      "src": "static/img/devices/webp/3.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/4.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/4.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev4",
    attrs: {
      "src": "static/img/devices/webp/4.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/5.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/5.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev-2",
    attrs: {
      "src": "static/img/devices/webp/5.webp"
    }
  })]), _vm._v(" "), _c('picture', [_c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/webp/6.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "noselect dev0",
    attrs: {
      "srcset": "static/img/devices/jp2/6.jp2",
      "type": "image/jp2"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noselect dev-1",
    attrs: {
      "src": "static/img/devices/webp/6.webp"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "explanation"
  }, [_c('div', {
    staticClass: "tile tile0"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": require("../../static/img/icons/icon_cpu.svg"),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('div', {
    staticClass: "container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.explanationModes) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tile tile1"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": require("../../static/img/icons/icon_gear.svg"),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('div', {
    staticClass: "container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.explanationWeighting)
    }
  })])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "tile tile2"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": require("../../static/img/icons/icon_fan.svg"),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('div', {
    staticClass: "container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.explanationStormMode) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "tile tile3"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": require("../../static/img/icons/icon_snowflake.svg"),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('div', {
    staticClass: "container_"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.explanationSummerMode) + "\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('picture', [_c('source', {
    attrs: {
      "srcset": "static/img/haqcs-as-a-controller-images/Sommerbetrieb.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/haqcs-as-a-controller-images/Sommerbetrieb.jpg",
      "loading": "lazy"
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tile tile4"
  }, [_c('img', {
    staticClass: "bg-icon",
    attrs: {
      "src": require("../../static/img/icons/icon_drops.svg"),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tile-content"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.lng.explanationHumidityThreshold) + "\n\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "paragraph-container_"
  }, [_c('p', {
    staticClass: "paragraph"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.lng.pCompatible) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.language === 'pl') ? _c('div', [_c('h3', {
    staticClass: "paragraph bold"
  }, [_vm._v("1. Marley MEnV HAQCS Edition")]), _vm._v(" "), _c('div', {
    staticClass: "paragraph"
  }, [_c('div', {
    staticClass: "flex-container_"
  }, [_c('div', [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width:3000px)",
      "srcset": "static/img/homepage-devices/marley-haqcs-edition_1041px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/homepage-devices/marley-haqcs-edition_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "srcset": "static/img/homepage-devices/marley-haqcs-edition_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/homepage-devices/marley-haqcs-edition.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.marleyMEnV180IIHAQCSEditionString)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  })]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "paragraph bold"
  }, [_vm._v(_vm._s(_vm.language === 'pl' ? '2' : '1') + ". Alnor HRU-WALL-WI")]), _vm._v(" "), _c('div', {
    staticClass: "paragraph"
  }, [_c('div', {
    staticClass: "flex-container_"
  }, [_c('div', [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width:3000px)",
      "srcset": "static/img/homepage-devices/alnor-hru-wall-wi_1600px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/homepage-devices/alnor-hru-wall-wi_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "srcset": "static/img/homepage-devices/alnor-hru-wall-wi_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/homepage-devices/alnor-hru-wall-wi.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.alnorHRUWALLString)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('h3', {
    staticClass: "paragraph bold"
  }, [_vm._v(_vm._s(_vm.language === 'pl' ? '3' : '2') + ". Marley MEnV 180")]), _vm._v(" "), _c('div', {
    staticClass: "paragraph"
  }, [_c('div', {
    staticClass: "flex-container_"
  }, [_c('div', [_c('picture', [_c('source', {
    staticClass: "elevation-2",
    attrs: {
      "media": "(min-width:3000px)",
      "srcset": "static/img/homepage-devices/marley-kit_1600px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "elevation-2",
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/homepage-devices/marley-kit_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "elevation-2",
    attrs: {
      "srcset": "static/img/homepage-devices/marley-kit_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "elevation-2",
    attrs: {
      "src": "static/img/homepage-devices/marley-kit.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.marleyMEnV180String)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('h3', {
    staticClass: "paragraph bold"
  }, [_vm._v(_vm._s(_vm.language === 'pl' ? '4' : '3') + ". Prana 150 " + _vm._s(_vm.lng.and) + " 200 C / G")]), _vm._v(" "), _c('div', {
    staticClass: "paragraph"
  }, [_c('div', {
    staticClass: "flex-container_"
  }, [_c('div', [_c('picture', [_c('source', {
    staticClass: "elevation-2",
    attrs: {
      "media": "(min-width:3000px)",
      "srcset": "static/img/homepage-devices/prana-kit_1600px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "elevation-2",
    attrs: {
      "media": "(min-width:1024px)",
      "srcset": "static/img/homepage-devices/prana-kit_1024px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('source', {
    staticClass: "elevation-2",
    attrs: {
      "srcset": "static/img/homepage-devices/prana-kit_800px.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "elevation-2",
    attrs: {
      "src": "static/img/homepage-devices/prana-kit.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.lng.prana150String)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('h3', {
    staticClass: "paragraph bold"
  }, [_vm._v(_vm._s(_vm.language === 'pl' ? '5' : '4') + ". " + _vm._s(_vm.lng.simpleFans))]), _vm._v(" "), _c('div', {
    staticClass: "paragraph"
  }, [_c('div', {
    staticClass: "flex-container_"
  }, [_c('div', [_c('picture', [_c('source', {
    attrs: {
      "srcset": "static/img/homepage-devices/unibox.webp",
      "type": "image/webp"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/homepage-devices/unibox.jpg",
      "loading": "lazy"
    }
  })])], 1), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.lng.simpleString) + "\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  })])]), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "padding": "8px 64px"
    },
    attrs: {
      "tile": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "row-sm": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "124px"
    }
  }, [_c('div', {
    staticClass: "div-center"
  }, [_c('span', {
    staticClass: "span-center"
  }, [_c('p', {
    staticClass: "heading-big"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.contact) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "heading-big grey--text text--darken-2",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.areYouInterested) + "\n\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "height": "124px"
    }
  }, [_c('div', {
    staticClass: "div-center-124 heading-big grey--text text--darken-2 hidden-xs-only"
  }, [_c('span', {
    staticClass: "span-center"
  }, [_c('v-icon', [_vm._v("phone")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("+49 1522 8619 710")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "div-center-124 heading grey--text text--darken-2 hidden-sm-and-up"
  }, [_c('span', {
    staticClass: "span-center"
  }, [_c('v-icon', [_vm._v("phone")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("+49 1522 8619 710")])], 1)])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": ""
    }
  }, [_c('div', {
    staticStyle: {
      "height": "124px"
    }
  }, [_c('div', {
    staticClass: "div-center-124 heading-big grey--text text--darken-2 hidden-xs-only"
  }, [_c('a', {
    staticClass: "a-nocolor",
    attrs: {
      "href": "mailto:info@hapla.eu"
    }
  }, [_c('span', {
    staticClass: "span-center"
  }, [_c('v-icon', [_vm._v("mail")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("info@hapla.eu")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "div-center-124 heading grey--text text--darken-2 hidden-sm-and-up"
  }, [_c('a', {
    staticClass: "a-nocolor",
    attrs: {
      "href": "mailto:info@hapla.eu"
    }
  }, [_c('span', {
    staticClass: "span-center"
  }, [_c('v-icon', [_vm._v("mail")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("info@hapla.eu")])], 1)])])])])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-2",
    staticStyle: {
      "padding": "8px 64px"
    },
    attrs: {
      "tile": ""
    },
    on: {
      "mouseover": function($event) {
        _vm.showProps = true
      },
      "touchmove": function($event) {
        _vm.showProps = true
      }
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "75px"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-2"
  }, [_c('div', {
    staticClass: "heading hidden-xs-only"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.contactFormNotice) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "heading-small hidden-sm-and-up"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.lng.contactFormNotice) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.scrollToTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.lng.linkContact
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "block": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mail")]), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.lng.openContactFormButton) + "\n\t\t\t\t\t\t\t")], 1)], 1)], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content content-seperator"
  }, [_c('div', {
    staticClass: "tile separator-line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "images"
  }, [_c('img', {
    staticClass: "img0",
    attrs: {
      "src": require("../assets/haqcs-as-a-controller-images/top-strip/0.png"),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img1",
    attrs: {
      "src": require("../assets/haqcs-as-a-controller-images/top-strip/1.png"),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img2",
    attrs: {
      "src": require("../assets/haqcs-as-a-controller-images/top-strip/2.png"),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img3",
    attrs: {
      "src": require("../assets/haqcs-as-a-controller-images/top-strip/3.png"),
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img4",
    attrs: {
      "src": require("../assets/haqcs-as-a-controller-images/top-strip/4.png"),
      "loading": "lazy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "images"
  }, [_c('img', {
    staticClass: "no-shadow",
    attrs: {
      "src": require("../assets/haqcs-as-a-controller-images/weighting.svg"),
      "loading": "lazy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/haqcs-as-a-controller-images/storm_mode.png"),
      "loading": "lazy"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-706eab1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 159
// module chunks = 1 2